/* libs */
import { createLogic } from "redux-logic";
/* action helpers */
import * as ActionTypes from "../../actions/actionTypes";
import * as PagesActions from "../../actions/pagesActions";

const editPagesSuccessLogic = createLogic({
	type: ActionTypes.EDIT_PAGE_SUCCESS,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		dispatch(PagesActions.resetCurrentPage());
		dispatch(PagesActions.loadPages(action.expId));
		done();
	},
});

export default [editPagesSuccessLogic];
